<template>
  <div style="background-color: white; min-height: 100vh; display: flex; flex-direction: column;">
    
    <Header type="white" />

    <div class="news-detail-container" v-if="!loading">
      
      <!-- Ana Kapak Görseli -->
      <img v-if="newsData.image" :src="newsData.image" class="news-banner" alt="Haber Görseli" />

      <!-- İçerik Alanı -->
      <div class="news-content-wrapper">
        <h1 class="news-title">{{ newsData.title }}</h1>
        
        <!-- Koyu Özet Metni -->
        <p class="news-lead" v-if="newsData.lead">{{ newsData.lead }}</p>
        
        <!-- Ana Metin (Satır atlamalarını koruyarak gösterir) -->
        <div class="news-body" style="white-space: pre-wrap;">{{ newsData.content }}</div>
      </div>
      
    </div>

    <div v-else style="text-align: center; padding: 100px; color: #888;">
      Haber İçeriği Yükleniyor...
    </div>

    <!-- Sitenin orijinal footer bileşeni -->
    <Footer style="margin-top: auto;" />
    
  </div>
</template>

<script>
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { initializeApp, getApps, getApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBxpNV_8UazGQ3pMReWWIdROn7AZlMT17Y",
  authDomain: "baumind-45d99.firebaseapp.com",
  projectId: "baumind-45d99",
  storageBucket: "baumind-45d99.firebasestorage.app",
  messagingSenderId: "982282716223",
  appId: "1:982282716223:web:25ebcf827c8e87c555248a",
  measurementId: "G-FDZLC80DZ2"
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const db = getFirestore(app);

export default {
  name: "NewsDetail",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      newsData: {},
      loading: true,
    };
  },
  async mounted() {
    await this.fetchNewsDetail();
  },
  watch: {
    '$route.params.id'() {
      this.fetchNewsDetail();
    }
  },
  methods: {
    async fetchNewsDetail() {
      this.loading = true;
      const routeId = this.$route.params.id; 
      if (!routeId) { this.loading = false; return; }

      try {
        const querySnapshot = await getDocs(collection(db, "haberler"));
        let matchedDoc = null;
        querySnapshot.forEach((docSnap) => {
          if (docSnap.id.toLowerCase() === routeId.toLowerCase()) { matchedDoc = docSnap; }
        });

        if (matchedDoc && matchedDoc.exists()) {
          this.newsData = matchedDoc.data();
        }
      } catch (error) { console.error("Hata:", error); } finally { this.loading = false; }
    }
  }
};
</script>

<style scoped>
.news-detail-container {
  width: 100%;
  padding: 0 5%;
  box-sizing: border-box;
}

.news-banner {
  width: 100%;
  max-width: 1200px;
  margin: 40px auto;
  display: block;
  border-radius: 4px;
  object-fit: contain;
}

.news-content-wrapper {
  width: 100%;
  max-width: 1100px;
  margin: 0 auto 80px auto;
  color: #111;
  font-family: "DM Sans", sans-serif;
}

.news-title {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 30px;
  line-height: 1.3;
}

.news-lead {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.6;
  margin-bottom: 40px;
  color: #000;
}

.news-body {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
}

@media screen and (max-width: 768px) {
  .news-title { font-size: 28px; }
  .news-lead { font-size: 16px; }
  .news-body { font-size: 15px; }
  .news-banner { margin: 20px auto; }
}
</style>